<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="eight wide column">
            <Breadcrumb>
              <router-link class="section" to="/profiles">Perfis de Acesso</router-link>
              <i class="right chevron icon divider"></i>
              <div class="active section">{{sectionName}}</div>
            </Breadcrumb>
          </div>
          <div v-show="persisted" class="eight wide right aligned column">
            <div class="actions">
              <router-link class="section" to="/profiles/new"><i class="plus icon"></i>Novo Perfil de Acesso</router-link>
              <a @click.prevent="openHistory" ><i class="history icon"></i>Histórico</a>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <HistoryModal ref="history" resource="Profile" :item_id="form.id" />
      <form :class="['ui small', {error: anyError}, 'form']" @submit.prevent="save">
        <div class="ui padded grid">
          <div v-show="loading" class="ui active inverted dimmer">
            <div class="ui text loader">Carregando...</div>
          </div>
          <div class="row">
            <div class="eight wide column">
              <div :class="[{error: errors.enable}, 'field']" :data-content="errorsTo('enable')">
                <div class="ui toggle checkbox">
                  <input type="checkbox" id="profile-form-enable" name="enable" v-model="form.enable" />
                  <label for="profile-form-enable">Perfil de Acesso ativo?</label>
                </div>
              </div>
              <br />
              <div :class="['required', {error: errors.description}, 'field']" :data-content="errorsTo('description')">
                <label for="profile-form-description">Descrição</label>
                <input type="text" autofocus id="profile-form-description" name="name" v-model="form.description" />
              </div>
              <div :class="[{error: errors.obs}, 'field']" :data-content="errorsTo('obs')">
                <label for="profile-form-obs">Observações:</label>
                <textarea id="profile-form-obs" name="obs" v-model="form.obs"></textarea>
              </div>
            </div>
          </div> <!-- row -->
          <div class="row">
            <div class="sixteen wide column">
              <div class="ui divider"></div>
              <div class="field">
                <button @click="save" type="button" name="save" class="ui submit blue button"><i class="save icon"></i>Salvar</button>
                <a v-show="persisted" class="delete" @click.prevent="remove"><i class="trash icon"></i>Remover Perfil de Acesso</a>
              </div>
            </div>
          </div>
        </div> <!-- grid -->
      </form>
    </template>
  </PageLayout>
</template>

<script>
  import Api from '@/resources/Api'
  import CepResource from '@/resources/Cep'
  import Breadcrumb from '@/components/breadcrumb'
  import PageLayout from '@/layouts/page_layout'
  import HistoryModal from '@/components/history_modal'

  export default {
    name: 'users',
    components: { Breadcrumb, PageLayout, HistoryModal },

    data () {
      return {
        loading: false,
        errors: {},
        form: {
          id: null,
          description: null,
          obs: null,
          enable: true
        }
      }
    },

    computed: {
      persisted() {
        return this.form.id != null
      },

      sectionName() {
        return this.persisted ? `Editar Perfil de Acesso - ${this.form.id}` : "Novo Perfil de Acesso"
      },

      anyError() {
        return !_.isEmpty(this.errors)
      }
    },

    mounted () {
      this.init()
    },

    methods: {
      init () {
        if(this.$route.params.id) {
          this.fetch(this.$route.params.id)
        }
      },

      errorsTo (key) {
        const errors = _.isEmpty(this.errors[key]) ? [] : this.errors[key]
        return errors.join(', ')
      },

      _setErrors(errors) {
        this.errors = _.clone(errors)
        setTimeout(() => {
          $('.error.field').popup()
        }, 100);
      },

      openHistory () {
        this.$refs.history.open()
      },

      save () {
        this.loading = true
        this._setErrors({});

        Api.profiles.save(this.form).then(async (response) => {
          this.$toast.show("Perfil de Acesso salvo com sucesso", "success");
          this.form = _.clone(response.data.profile)
        }).catch((error) => {
          if (error.response) {
            const errors = error.response.data.errors;
            const baseErrors = errors && errors.base;
            if (baseErrors && baseErrors.length) {
              this.$toast.show(baseErrors.join(', '), 'error');
            } else {
              this.$toast.show("Erro ao salvar Perfil de Acesso", "error");
            }
            this._setErrors(errors)
          } else {
            throw error;
          }
        }).finally(() => {
          this.$scrollTop();
          this.loading = false
        });
      },

      remove() {
        const removeIt = confirm("Remover Perfil de Acesso?");
        if(removeIt) {
          this.loading = true
          Api.profiles.destroy(this.form.id).then(async (response) => {
            this.$toast.show("Perfil de Acesso removido com sucesso", "success");
            this.$router.push({name: 'profiles'});
          }).catch((error) => {
            if (error.response) {
              const errors = error.response.data.errors;
              const baseErrors = errors && errors.base;
              if (baseErrors && baseErrors.length) {
                this.$toast.show(baseErrors.join(', '), 'error');
              } else {
                this.$toast.show("Erro ao remover profileo", "error");
              }
              this._setErrors(errors)
            } else {
              throw error;
            }
          }).finally(() => {
            this.$scrollTop();
            this.loading = false
          });
        }
      },

      fetch(id) {
        this.loading = true
        Api.profiles.fetch(id).then(async (response) => {
          this.form = _.clone(response.data.profile)
        }).catch((error) => {
          if (error.response) {
            this.$toast.show("Erro ao buscar profileo", "error");
            this.$router.push({name: 'profiles'});
          } else {
            throw error;
          }
        }).finally(() => {
          this.$scrollTop();
          this.loading = false
        });
      }
    }
  }
</script>
